import reducer from './trackingDescription';
import { actionCreators, TrackingDescriptionActionType } from './trackingDescription.actionCreators';
import * as actionTypes from './trackingDescription.actionTypes';

export * from './trackingDescription'; // expose all types
export * from './trackingDescription.selectors';
export type ActionType = TrackingDescriptionActionType;
export { actionTypes, actionCreators };
export default reducer;
